export const GROUP_PREFIX = "group::";
export const NON_API_PREFIX = "non-api::";

export const getCollectionDetailUrl = (id: string) => {
  if (id.startsWith(GROUP_PREFIX)) {
    return `/dataset/group/${id.substring(GROUP_PREFIX.length)}`;
  } else if (id.startsWith(NON_API_PREFIX)) {
    return `/dataset/storage/${id.substring(NON_API_PREFIX.length)}`;
  }
  return `/collections/${id}`;
};
